(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  // Mobile announcement slider with arrow + autoplay + seamless infinite loop.
  const mobileAnnouncementBars = document.querySelectorAll('[data-announcement-mobile]');

  mobileAnnouncementBars.forEach((bar) => {
    const track = bar.querySelector('[data-mobile-track]');
    if (!track) return;

    const originalSlides = Array.from(track.children);
    const controls = Array.from(bar.querySelectorAll('[data-direction]'));
    if (originalSlides.length <= 1 || controls.length === 0) return;

    // Clone edge slides so first/last jump happens offscreen.
    const firstClone = originalSlides[0].cloneNode(true);
    const lastClone = originalSlides[originalSlides.length - 1].cloneNode(true);
    firstClone.setAttribute('aria-hidden', 'true');
    lastClone.setAttribute('aria-hidden', 'true');
    track.insertBefore(lastClone, originalSlides[0]);
    track.appendChild(firstClone);

    const slides = Array.from(track.children);
    const totalRealSlides = originalSlides.length;
    let activeIndex = 1;
    const mobileMedia = window.matchMedia('(max-width: 768px)');
    const autoplayMs = Number(bar.dataset.autoplayMs || 0);
    let autoplayTimer;
    let isTransitioning = false;

    // Move track to slide index, optional transition toggle for silent snaps.
    const setActiveSlide = (nextIndex, animate = true) => {
      activeIndex = nextIndex;
      track.style.transition = animate ? 'transform 220ms ease' : 'none';
      track.style.transform = `translate3d(-${activeIndex * 100}%, 0, 0)`;
    };

    // When landing on clone, snap to matching real slide without animation.
    const normalizeIndex = () => {
      if (activeIndex === 0) {
        setActiveSlide(totalRealSlides, false);
      } else if (activeIndex === totalRealSlides + 1) {
        setActiveSlide(1, false);
      }
    };

    // Keep one interval alive at most.
    const clearAutoplay = () => {
      if (!autoplayTimer) return;
      window.clearInterval(autoplayTimer);
      autoplayTimer = null;
    };

    // Reuse section autoplay speed (seconds -> ms) for mobile cycling.
    const startAutoplay = () => {
      clearAutoplay();
      if (!mobileMedia.matches || autoplayMs <= 0) return;

      autoplayTimer = window.setInterval(() => {
        if (!mobileMedia.matches || isTransitioning) return;
        isTransitioning = true;
        setActiveSlide(activeIndex + 1);
      }, autoplayMs);
    };

    controls.forEach((control) => {
      control.addEventListener('click', () => {
        if (!mobileMedia.matches || isTransitioning) return;

        const step = Number(control.dataset.direction || 0);
        isTransitioning = true;
        setActiveSlide(activeIndex + step);
        startAutoplay();
      });
    });

    track.addEventListener('transitionend', () => {
      normalizeIndex();
      isTransitioning = false;
    });

    mobileMedia.addEventListener('change', () => {
      if (mobileMedia.matches) {
        startAutoplay();
      } else {
        clearAutoplay();
      }
    });

    bar.addEventListener('mouseenter', clearAutoplay);
    bar.addEventListener('mouseleave', startAutoplay);
    bar.addEventListener('touchstart', clearAutoplay, { passive: true });
    bar.addEventListener('touchend', startAutoplay, { passive: true });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        clearAutoplay();
      } else {
        startAutoplay();
      }
    });

    setActiveSlide(1, false);
    startAutoplay();
  });

  } catch(e) { console.error(e); }
})();
})();
